import { render, staticRenderFns } from "./MarketingPricing.vue?vue&type=template&id=a3889c6e&"
import script from "./MarketingPricing.vue?vue&type=script&lang=ts&"
export * from "./MarketingPricing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports